import { useFactua } from 'context/FactuaContext';
import Factua from '../Factua';

export default function GlobalIframe(): JSX.Element {
  const { isOpen, iframeLink, closeFactua } = useFactua();

  return <Factua show={isOpen} iframeLink={iframeLink} onClose={closeFactua} />;
}
